import { useCallback } from 'react'
import { LayoutGroup, motion } from 'framer-motion'
import { ListTodo, Calendar as CalendarIcon, Kanban as KanbanIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { snappySpring } from './motion-presets'

const VIEW_ITEMS = [
  {
    id: 'list',
    label: 'List',
    icon: ListTodo,
  },
  {
    id: 'calendar',
    label: 'Calendar',
    icon: CalendarIcon,
  },
  {
    id: 'kanban',
    label: 'Kanban',
    icon: KanbanIcon,
  },
]

const ViewSwitcherItem = ({ id, label, icon: Icon, activeTab, handleViewSelect }) => {
  const isActive = activeTab === id
  const handleClick = useCallback(
    (event) => {
      handleViewSelect(id)
      window.record('view_changed', { view: id })
    },
    [handleViewSelect, id],
  )
  return (
    <motion.button
      layout="position"
      data-view={id}
      type="button"
      onClick={handleClick}
      whileTap={{
        y: 1,
      }}
      className={cn(
        'relative px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
        isActive ? 'text-primary-foreground' : 'text-muted-foreground hover:text-foreground',
      )}
    >
      {isActive && (
        <motion.div
          layoutId="view-switcher-indicator"
          className="absolute inset-0 rounded-md bg-primary shadow-sm"
          transition={snappySpring}
        />
      )}
      <span className="relative z-10 flex items-center gap-2">
        <motion.span
          animate={
            isActive
              ? {
                  opacity: 1,
                }
              : {
                  opacity: 0.8,
                }
          }
          transition={snappySpring}
        >
          <Icon className="h-4 w-4" />
        </motion.span>
        <span className="hidden sm:inline">{label}</span>
      </span>
    </motion.button>
  )
}

export function ViewSwitcher({ activeTab, handleViewSelect }) {
  return (
    <LayoutGroup id="view-switcher">
      <motion.div
        layout="position"
        className="flex items-center gap-1 p-1"
        transition={snappySpring}
      >
        {VIEW_ITEMS.map((view) => (
          <ViewSwitcherItem
            key={view.id}
            id={view.id}
            label={view.label}
            icon={view.icon}
            activeTab={activeTab}
            handleViewSelect={handleViewSelect}
          />
        ))}
      </motion.div>
    </LayoutGroup>
  )
}
